export default "__VITE_ASSET__DUk7veW6__"